import axios from '@/axios.config';
import { defineStore } from "pinia";

export const useAppDataStore = defineStore("appData", {
	state: () => ({
		appData: {
			artworks: [],
			paths: [],
			loaded: false,
			langsLoaded: false,
			lang: localStorage.getItem("firstLanguageLang") || 'it',
			langLabel: 'Italiano',
			labels: {},
			languages: {},
			byId: {
				artworks: new Map(),
				paths: new Map(),
			}
		}
	}),

	actions: {
		async getAppData_old(lang = localStorage.getItem("firstLanguageLang") || 'it') {
			this.setAppDataLoaded(false);

			const originalAppData = this.appData;
			const appDataLocal = localStorage.getItem("appData");
			let appData = null;

			if (appDataLocal) {
				this.appData = JSON.parse(appDataLocal);
			}
			else {
				let appData = await axios.get("/qzr-data/app-data?lang=" + lang);
				this.appData = appData.data;
				localStorage.setItem("appData", JSON.stringify(appData.data));
			}

			this.appData = Object.assign({}, originalAppData, appData.data);

			this.setAppDataLoaded(true);

		},
		async getAppData(lang = localStorage.getItem('firstLanguageLang') || 'it') {
			// 1. flag di caricamento
			this.setAppDataLoaded(false);

			// 2. riferimenti a cache e lingua della cache
			const cachedData  = localStorage.getItem('appData');
			const cachedLang  = localStorage.getItem('appDataLang');
			const cachedVersion = localStorage.getItem('appDataVersion');
			let   freshData   = null;   // conterrà i dati effettivi

			const appDataVersion = (await axios.get(`/qzr-data/app-data-version`)).data;

			if (cachedData && cachedLang === lang && parseInt(cachedVersion) === parseInt(appDataVersion)) {
				// 3A ▸ cache valida → usa dati locali
				freshData = JSON.parse(cachedData);
				console.log('App Data: dati caricati da cache locale.');
			} else {
				// 3B ▸ nessuna cache o lingua diversa → fetch da API
				freshData = (await axios.get(`/qzr-data/app-data?lang=${lang}`)).data;

				// salva su localStorage per la prossima volta
				localStorage.setItem('appData',     JSON.stringify(freshData));
				localStorage.setItem('appDataLang', lang);
				localStorage.setItem('appDataVersion', appDataVersion);
				console.log('App Data: dati caricati da API.');
			}

			// 4. merge (shallow) con eventuali campi pre-esistenti nello store
			this.appData = { ...this.appData, ...freshData, lang };

			// 5. pronto!
			this.setAppDataLoaded(true);
		},

		async getAppData_localforage(lang = localStorage.getItem('firstLanguageLang') || 'it') {
			lang;
		},
		updateRedirectId(id) {
			this.appData.redirectId = id;
		},
		findTranslation(currentId, targetLang) {
			for (let type in this.appData) {
				if (this.appData[type].length && typeof this.appData[type] === 'object') {
					for (let obj of this.appData[type]) {
						let objectToFind = null;

						for (let translation in obj.translations) {
							/* 
							console.log('----------------------------');
							console.log(obj.translations);
							console.log('translation: '+translation);
							console.log(obj.translations[translation]);
							console.log('currentId: '+currentId+' translation: '+obj.translations[translation]);
							console.log('*****************************'); */


							if (parseInt(obj.translations[translation]) == parseInt(currentId)) {
								objectToFind = obj;
								break;
							}
						}
						

						if (objectToFind) {
							return objectToFind.translations[targetLang] || null;
						}
					}
				}
			}

			return null;
		},
		setAppDataLoaded(status) {
			this.appData.loaded = status;
		},
		async loadLang(langCode, router) {
			// 1. aggiorno lo store e salvo su localStorage
			this.appData.lang = langCode;
			//localStorage.clear();
			localStorage.setItem("firstLanguageLang", langCode);

			await this.getAppData(langCode, router);
			await this.setLabels(langCode);
			const { name, params } = router.currentRoute.value;
			const newParams = { ...params, lang: langCode };

			switch (name) {
				case "Artwork":
					newParams.id = this.findTranslation(params.id, langCode) || params.id;
					console.log(newParams.id);
					console.log(langCode);
					console.log(this.findTranslation(params.id, langCode));
					break;
				case "Path":
					newParams.id = this.findTranslation(params.id, langCode) || params.id;
					break;
				case "PathArtwork":
					newParams.id = this.findTranslation(params.id, langCode) || params.id;
					newParams.artworkId = this.findTranslation(params.artworkId, langCode) || params.artworkId;
					break;
				// aggiungi qui altri nomi di rotta che usano ID (Gallery, ecc.)
			}

			router.push({ name, params: newParams });

		},
		/* 
		loadLang(langCode, router) {
			this.appData.lang = langCode;
			
			if(!this.appData.languages) {
				this.getLanguages();
			}

			const lang = this.appData.languages.langs[langCode];
			this.appData.langLabel = lang.native_name;

			router.push({ name: 'Home', params: { lang: langCode } });
		}, */

		setLang(langCode, router) {
			this.appData.lang = langCode;
			localStorage.setItem("firstLanguageLang", langCode);
			this.getAppData(langCode, router);
		},
		async setLabels(lang = 'it') {
			const labels = await axios.get("/qzr-data/wpml-strings?lang=" + lang);
			this.appData.labels = labels.data;
			this.appData.langLabel = this.appData.languages && this.appData.languages[lang] ? this.appData.languages[lang].native_name : 'Italiano';
		},
		async getLanguages() {
			const languages = await axios.get("/qzr-data/wpml-languages");
			this.appData.langsLoaded = true;
			this.appData.languages = languages.data;
		}
	}
});